export class PndRouteUtils {
  /**
   * Return the RouteId (prefix-sufix), or an empty string if not available in
   * passed object
   */
  static getRouteId(route: { routePrefix: string; routeSuffix: string }): string {
    return route && route.routePrefix && route.routeSuffix ? `${route.routePrefix}-${route.routeSuffix}` : '';
  }
}
